import React, { useEffect, useState } from "react";
import { getRequests, statusCount } from "../actions/messageActions";
import Pagination from "../components/Pagination";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "../components/Modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loading from "../components/Loading";
import DashboardDetails from "../components/DashboardDetails";
import DashboardCountDetails from "../components/DashboardCountDetails";
import { useDispatch, useSelector } from "react-redux";
var countDownTimer;
const Admin = () => {
  const { state, pathname } = useLocation();

  const dispatch = useDispatch();
  const statusType = useSelector((state) => state.messageDetail);
  const navigate = useNavigate();
  const [requests, setRequests] = useState(null);
  const [error, setError] = useState(null);
  const [session, setSession] = useState({
    time: 0,
    open: false,
  });
  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const numberPerPage = 5;
  const indexOfLastArticle = currentPage * numberPerPage;
  const indexOfFirstArticle = indexOfLastArticle - numberPerPage;
  const paginate = (number) => setCurrentPage(number);

  function timer(timestamps) {
    const countDown = new Date(timestamps).getTime();

    countDownTimer = setInterval(() => {
      const now = new Date(
        new Date().toLocaleString("en-US", { timeZone: "Asia/Manila" })
      ).getTime();

      // Find the distance between now and the count down date
      const distance = countDown - now;

      // Time calculations for days, hours, minutes and seconds
      // var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      // var hours = Math.floor(
      //   (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      // );
      // const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Output the result in an element with id="demo"
      // days + "d " + hours + "h " +

      if (seconds < 0) {
        clearInterval(countDownTimer);
        setSession({ time: false });
        window.location.pathname = `${pathname}`;
      } else if (seconds <= 30 && seconds >= 0) {
        setSession({ time: seconds });
      }

      // If the count down is over, write some text
    }, 1000);
  }

  useEffect(() => {
    (async function getCountsAndRequests() {
      const { data, session: sessionTime, requestError } = await getRequests();
      const dataCounts = await statusCount();
      dispatch({
        type: "MESSAGE_STATUS_TYPE",
        payload: dataCounts,
      });
      !requestError ? setRequests(data?.reverse()) : setError(requestError);
      sessionTime && timer(sessionTime, false);
    })();
  }, []);

  useEffect(() => {
    if (error?.param === "No token found") {
      navigate("/login", {
        state: {
          message: "Unauthorized. Please login",
        },
      });
    }
    if (error?.param === "invalidToken") {
      navigate("/login", {
        state: { message: "Session timeout. Please login again!" },
      });
    }
  }, [error, navigate]);
  // useEffect(() => {
  //   console.log(state.message);
  //   toast.success(`${state.message}`);
  // }, [state]);
  if (requests == null) return <Loading />;

  return (
    <div className="admin">
      <ToastContainer
        autoClose={3000}
        toastStyle={{ backgroundColor: "green", color: "white" }}
      />
      <Modal
        time={session?.time}
        setSession={setSession}
        timer={timer}
        countDownTimer={countDownTimer}
      ></Modal>

      <DashboardCountDetails
        totalRequests={requests.length}
        statusType={statusType}
      />
      <div className="request-details">
        <h2>Request Details</h2>
        <table className="request-lists">
          <tbody>
            <tr>
              <th>Request</th>
              <th>Fullname</th>
              <th>Email</th>
              <th>Status</th>
              <th>Send Date</th>
              <th>Actions</th>
            </tr>
            <DashboardDetails
              indexOfFirstArticle={indexOfFirstArticle}
              indexOfLastArticle={indexOfLastArticle}
              requests={requests}
              setRequests={setRequests}
            />
          </tbody>
        </table>
        <Pagination
          numberPerPage={numberPerPage}
          totalArticles={requests.length}
          paginate={paginate}
          currentPage={currentPage}
        />
      </div>
    </div>
  );
};

export default Admin;
